import React, { Component } from 'react'
import { connect } from "react-redux";
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Selectsearch from "react-select";
// app config
import AppConfig from 'Constants/AppConfig';
import DatePicker from "react-datepicker";
import moment from 'moment';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
    FormGroup,
    Label,
} from 'reactstrap';

import {
    studentTournamentScore,
    fetchTournamentChart,
    fetchTournamentProcessReport,
    fetchTournamentScore,
    deleteTournamentScore,
    fetchTournamentProcess,
    deleteTournamentProcess,
    studentTournamentProcess,
    fetchPlayerIntervention
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";

import ViewReport from '../../../golf/tournamentreport/component/viewreport';
import AddItem from '../../../golf/tournamentscore/component/addform';
import EditItem from '../../../golf/tournamentscore/component/editform';

import AddPRItem from '../../../golf/tournamentprocess/component/addform';
import EditPRItem from '../../../golf/tournamentprocess/component/editform';

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';


class TournamentData extends Component {

    constructor(props) {

        super(props);

        this.confirmationDialog = React.createRef();
        this.confirmationPRDialog = React.createRef();
        this.state = {
            student: this.props.data.student,
            startdate: this.props.data.startdate,
            enddate: this.props.data.enddate,
            viewdiv1: true,
            viewdiv2: true,
            viewdiv3: false,
            viewdiv4: true,
            adddiv: false,
            loader: false,
            selectdates: '',
            seldata: [],
            dacheckbox: false,
            filappy: 0,
            selround: [],
            allcourse: [],
            listdiv: false,
            editdiv: false,
            addprdiv: false,
            listprdiv: false,
            editprdiv: false,
            club: '',
            seldate: '',
            country: '',
            round: '',
            eid: '',
            drvsh_1: '',
            drvsc_1: '',
            fwsh_1: '',
            fwsc_1: '',
            apssh_1: '',
            apssc_1: '',
            wpsh_1: '',
            wpsc_1: '',
            bpsh_1: '',
            bpsc_1: '',
            chpsh_1: '',
            chpsc_1: '',
            putsh_1: '',
            putsc_1: '',
            spssh_1: '',
            spssc_1: '',
        };

        this.onBackSection = this.onBackSection.bind(this);
        this.ViewReport = this.ViewReport.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.selhandleChange = this.selhandleChange.bind(this);
        this.addEntry = this.addEntry.bind(this);
        this.viewList = this.viewList.bind(this);
        this.filterSubmit = this.filterSubmit.bind(this);
        this.onEditBack = this.onEditBack.bind(this);
        this.addPREntry = this.addPREntry.bind(this);
        this.viewPRList = this.viewPRList.bind(this);
        this.onEditPRBack = this.onEditPRBack.bind(this);

    }

    UNSAFE_componentWillMount() {

    }



    selectstart = (date) => {
        this.setState({ startdate: date });
    }

    selectend = (date) => {
        this.setState({ enddate: date });
    }

    handleSubmit(evt) {
        evt.preventDefault();
        var student = this.state.student;
        if (this.state.startdate == "") {
            var stdate = "";
        } else {
            var stdate = moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        }
        if (this.state.enddate == "") {
            var eddate = "";
        } else {
            var eddate = moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        }

        var allround = this.state.selround;
        var alltournament = this.state.allcourse;

        this.setState({
            loader: true,
            viewdiv2: false,
        });

        this.props.fetchTournamentProcessReport(student, stdate, eddate, tournament, round);
        this.props.studentTournamentScore(student, stdate, eddate).then((data) => {

            this.setState({
                loader: false,
                viewdiv2: true,
            });

        });


    }

    ViewReport() {
        var seldate = this.state.seldata;
        if(seldate!=''){
            var alldate = seldate.join(',');
            var student = this.state.student;
            var course = '';
            this.setState({
                loader: true,
            });

            this.props.fetchTournamentChart(student, alldate, course).then((data) => {
                var resdata = data;
                var course = [];
                var rescourse = resdata.tournament;
                if (resdata.length != 0) {
                    {
                        rescourse.map((teamval, idx) => (
                            course.push({
                                id: teamval.gtlID,
                                name: teamval.tournament,
                            })
                        ))
                    }
                }

                this.setState({
                    allcourse: course,
                    loader: false,
                    viewdiv2: false,
                    viewdiv3: true,
                });
            });
        }else{
            alert('Please the tournament for report');
        }

    }

    handleChange(id, event) {

        if (event.target.checked) {
            var seldate = event.target.value;
            this.setState({ seldata: [...this.state.seldata, seldate] })
        } else {
            var array = [...this.state.seldata];
            var index = array.indexOf(event.target.value)
            if (index !== -1) {
                array.splice(index, 1);
                this.setState({ seldata: array });
            }
        }


    }

    selhandleChange(event, id) {
        if (id == 1) {
            if (event.length == 0) {
                this.setState({
                    selround: []
                });
            } else {
                var allsel = [];
                event.map((stdval) => {
                    allsel.push(stdval.value);
                });
                this.setState({
                    selround: allsel
                });
            }
        } else if (id == 2) {
            if (event.length == 0) {
                this.setState({
                    allcourse: []
                });
            } else {
                var allsel = [];
                event.map((stdval) => {
                    allsel.push(stdval.value);
                });
                this.setState({
                    allcourse: allsel
                });
            }
        }
    }

    filterSubmit() {
        var student = this.state.student;
        if (this.state.startdate == "") {
            var stdate = "";
        } else {
            var stdate = moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        }

        if (this.state.enddate == "") {
            var eddate = "";
        } else {
            var eddate = moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        }
        var allround = this.state.selround;
        var alltournament = this.state.allcourse;
        if (allround.length == 0) {
            var round = "";
        } else {
            var round = allround.join(',');
        }

        if (alltournament.length == 0) {
            var tournament = "";
        } else {
            var tournament = alltournament.join(',');
        }

        this.setState({
            loader: true,
            viewdiv4: false,
            filappy: 1,
        });

        this.props.fetchTournamentProcessReport(student, stdate, eddate, tournament, round).then((data) => {
            this.setState({
                loader: false,
                viewdiv4: true,
            });

        });
    }

    onBackSection() {
        var student=this.state.student;
        var stdate='';
        var eddate='';
        this.props.fetchPlayerIntervention(student, stdate, eddate).then((data) => { 
            this.setState({
                seldata: [],
                viewdiv3: false,
                adddiv: false,
                listdiv: false,
                addprdiv: false,
                listprdiv: false,
                viewdiv2: true,
                viewdiv4: true,

            });
        });
    }

    addEntry() {
        this.setState({
            seldata: [],
            viewdiv3: false,
            viewdiv2: false,
            viewdiv4: false,
            adddiv: true,
        });

    }


    onEditBack() {

        this.setState({
            adddiv: false,
            editdiv: false,
            listdiv: false,
            viewdiv2: true,
            viewdiv4: true
        });

    }

    viewList() {
        var stdid = this.state.student;
        var start = '';
        var end = '';

        this.props.studentTournamentScore(stdid, start, end).then((data) => {

            this.setState({
                viewdiv3: false,
                viewdiv2: false,
                viewdiv4: false,
                listdiv: true,
            });

        });

    }

    editAssessment(assmval) {

        var id = assmval.gtrID;

        this.props.fetchTournamentScore(id).then((data) => {
            var resdata = data.data;

            this.setState({
                student: resdata[0].gtr_userID,
                club: resdata[0].gtr_course,
                tournament: resdata[0].gtr_tournament,
                country: resdata[0].gtr_country,
                round1date: resdata[0].gtr_rddate1,
                round2date: resdata[0].gtr_rddate2,
                round3date: resdata[0].gtr_rddate3,
                round4date: resdata[0].gtr_rddate4,
                view1: true,
                view2: (resdata[0].gtr_round >= 2) ? true : false,
                view3: (resdata[0].gtr_round >= 3) ? true : false,
                view4: (resdata[0].gtr_round >= 4) ? true : false,
                missedcut: resdata[0].gtr_misscut,
                position: resdata[0].gtr_misscut,
            });

            this.setState({
                viewdiv: false,
                listdiv: false,
                adddiv: false,
                editdiv: true,
            });

        });
    }

    deleteForm(assmval) {
        this.id = assmval.gtrID;
        this.usrid = assmval.gtr_userID;
        this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse) {

        if (popupResponse) {
            this.props.deleteTournamentScore(this.id, this.usrid);
            this.data = ""
        }
    }

    addPREntry() {

        this.setState({

            viewdiv3: false,
            viewdiv2: false,
            viewdiv4: false,
            addprdiv: true,
        });
    }


    onEditPRBack() {

        this.setState({
            addprdiv: false,
            editprdiv: false,
            listprdiv: false,
            viewdiv2: true,
            viewdiv4: true
        });

    }

    viewPRList() {
        var stdid = this.state.student;
        var start = '';
        var end = '';

        this.props.studentTournamentProcess(stdid, start, end).then((data) => {

            this.setState({
                viewdiv3: false,
                viewdiv2: false,
                viewdiv4: false,
                listprdiv: true,
            });

        });

    }

    editPRAssessment(gid) {
        this.props.fetchTournamentProcess(gid).then((data) => {
            var resdata = data.data;
            var tournamentid = parseInt(resdata[0].gtmd_tournament);
            this.setState({

                seldate: resdata[0].gtmd_date,
                country: resdata[0].gtmd_country,
                student: resdata[0].gtmd_userID,
                round: resdata[0].gtmd_round,
                club: tournamentid,
                eid: resdata[0].gtmdID,
                drvsh_1: resdata[0].gtmd_drvsh,
                drvsc_1: resdata[0].gtmd_drvsc,
                fwsh_1: resdata[0].gtmd_fwsh,
                fwsc_1: resdata[0].gtmd_fwsc,
                apssh_1: resdata[0].gtmd_apssh,
                apssc_1: resdata[0].gtmd_apssc,
                wpsh_1: resdata[0].gtmd_wpsh,
                wpsc_1: resdata[0].gtmd_wpsc,
                bpsh_1: resdata[0].gtmd_bpsh,
                bpsc_1: resdata[0].gtmd_bpsc,
                chpsh_1: resdata[0].gtmd_chpsh,
                chpsc_1: resdata[0].gtmd_chpsc,
                putsh_1: resdata[0].gtmd_putsh,
                putsc_1: resdata[0].gtmd_putsc,
                spssh_1: resdata[0].gtmd_spssh,
                spssc_1: resdata[0].gtmd_spssc,
            });


            this.setState({

                listprdiv: false,
                addprdiv: false,
                editprdiv: true,

            });

        });
    }

    deletePRForm(data) {
        this.data = data;
        this.confirmationPRDialog.current.openDialog();
    }

    deletePRDataPermanent(popupResponse) {

        if (popupResponse) {
            this.props.deleteTournamentProcess(this.data);
            this.data = ""
        }
    }


    render() {
        const { match, studentlists, tournamentscorelist, tournamentprocessreport, tournamentprocesslist, loading } = this.props;
        const reportlength = tournamentprocessreport.length;
        if (reportlength == 0) {
            var alltournament = [];
        } else {
            var fetchtour = tournamentprocessreport.tournament;
            var alltournament = fetchtour.map((trnval) => {
                return {
                    label: trnval.tournament,
                    value: trnval.gtlID
                }
            });
        }
        const allround = [
            {
                label: "Round 1",
                value: 1
            },
            {
                label: "Round 2",
                value: 2
            },
            {
                label: "Round 3",
                value: 3
            },
            {
                label: "Round 4",
                value: 4
            }
        ];

        const styles = {
            table: {
                border: "2px solid rgb(0, 0, 0)",
                borderColor: "rgb(0 0 0 / 49%)",
                borderStyle: "solid",
                color: "#000"
            },
            tabletrtd: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px",
                fontWeight: "500"
            },
            tabletrtdleft: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px"
            },
            tabletrtdhead: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px",
                fontWeight: "bold",
                textAlign: "center"
            }
        };

        const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive: 'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "tournament", label: "TOURNAMENT" },
            { name: "action", label: "EDIT" },
            { name: "action1", label: "DELETE" },

        ];
        const tabledata = tournamentscorelist.map((assmntval, idx) => {
            const ebtn = <IconButton className='text-info' onClick={() => this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;
            const dbtn = <IconButton className="text-danger" aria-label="Remove" onClick={() => this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;

            return {
                no: idx + 1,
                name: assmntval.student,
                cdate: assmntval.cdate,
                tournament: assmntval.gtl_name,
                action: ebtn,
                action1: dbtn,

            }
        });

        const columns2 = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "tournament", label: "TOURNAMENT" },
            { name: "round", label: "ROUND" },
            { name: "action", label: "EDIT" },
            { name: "action1", label: "DELETE" },

        ];
        const tableprdata = tournamentprocesslist.map((assmntval, idx) => {
            const ebtn = <IconButton className='text-info' onClick={() => this.editPRAssessment(assmntval.gtmdID)}><EditOutlinedIcon/></IconButton>;
            const dbtn = <IconButton className="text-danger" aria-label="Remove" onClick={() => this.deletePRForm(assmntval.gtmdID)}  ><DeleteOutlineOutlinedIcon/></IconButton>;

            return {
                no: idx + 1,
                name: assmntval.student,
                cdate: assmntval.cdate,
                tournament: assmntval.gtl_name,
                round: assmntval.gtmd_round,
                action: ebtn,
                action1: dbtn,

            }
        });
        return (
            <div className="saas-dashboard">
                <div className="row" style={{ marginBottom: "20px" }}>
                    <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                    <div className="col-lg-8"><h2 className="text-center">TOURNAMENT DATA</h2></div>
                    <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={() => this.props.onClick1(1)}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                </div>

                <div className="row">
                    {this.state.viewdiv1 &&

                        <div className="col-sm-12 col-lg-6" style={{ margin: "0 auto" }}>
                            <RctCollapsibleCard>
                                <form autoComplete="off" id="addform" onSubmit={(e) => this.handleSubmit(e)}>
                                    <div className="row">
                                        <div className="col-lg-5">
                                            <FormGroup >
                                                <DatePicker className="form-control" id="startdate" placeholderText="Start Date" name="startdate" required autoComplete="off"
                                                    selected={this.state.startdate}
                                                    onChange={this.selectstart}
                                                    dateFormat='yyyy-MM-dd'
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-5">
                                            <FormGroup >
                                                <DatePicker className="form-control" id="enddate" placeholderText="End Date" name="enddate" required autoComplete="off"
                                                    selected={this.state.enddate}
                                                    onChange={this.selectend}
                                                    dateFormat='yyyy-MM-dd'
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className="form-group">
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Filter" />
                                        </div>
                                    </div>
                                </form>
                            </RctCollapsibleCard>
                        </div>

                    }
                </div>

                {this.state.viewdiv2 &&
                    <div className="row">
                        <div className="col-sm-12 col-lg-6">
                            <RctCollapsibleCard heading="List" fullBlock>
                                <div className="col-md-12">
                                    <div className="as">
                                        <div className="float-left"><a onClick={this.addEntry} style={{ color: "blue" }}><span class="icon-plus"></span> Add</a> <a style={{ color: "orange", paddingLeft: "10px" }} onClick={this.viewList}><span class="icon-list"></span> List</a></div>
                                        <button type="button" className="mr-3 mb-3 btn btn-outline-success float-right" onClick={this.ViewReport} >View Report</button>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <Table>
                                        <TableHead>
                                            <TableRow hover>
                                                <TableCell>No</TableCell>
                                                <TableCell>NAME</TableCell>
                                                <TableCell>DATE</TableCell>
                                                <TableCell>TOURNAMENT</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>

                                            {tournamentscorelist.map((element, i) => (

                                                <TableRow key={i}>
                                                    <TableCell><input type="checkbox" name={'datecheckbox'} value={element.gtrID} onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" /></TableCell>
                                                    <TableCell>{element.student}</TableCell>
                                                    <TableCell>{element.cdate}</TableCell>
                                                    <TableCell>{element.gtl_name}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </div>
                            </RctCollapsibleCard>
                        </div>
                        <div className="col-sm-12 col-lg-6">
                            <RctCollapsibleCard>
                                <div className="row">
                                    <div><a onClick={this.addPREntry} style={{ color: "blue" }}><span class="icon-plus"></span> Add</a> <a style={{ color: "orange", paddingLeft: "10px" }} onClick={this.viewPRList}><span class="icon-list"></span> List</a></div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-lg-6">
                                        <FormGroup>
                                            <Label for="Select">Tournament *</Label>
                                            <Selectsearch isMulti id="tournament" name="tournament" defaultValue={this.state.allcourse} placeholder="Select Tournament" options={alltournament} onChange={e => this.selhandleChange(e, 2)} required />
                                        </FormGroup>
                                    </div>
                                    <div className="col-sm-12 col-lg-4">
                                        <FormGroup>
                                            <Label for="Select">Round *</Label>
                                            <Selectsearch isMulti id="round" name="round" defaultValue={this.state.selround} placeholder="Select Round" options={allround} onChange={e => this.selhandleChange(e, 1)} required />
                                        </FormGroup>
                                    </div>
                                    <div className="col-sm-12 col-lg-2">
                                        <div className="form-group">
                                            <button className="btn btn-outline-primary float-right" onClick={this.filterSubmit} >Filter</button>
                                        </div>
                                    </div>
                                </div>
                                {this.state.viewdiv4 &&
                                    <>
                                        {this.state.filappy == 1 && reportlength == 0 ?
                                            <div className="col-sm-12 col-lg-12">
                                                <h2 className="text-center" style={{ color: "red" }}>No Data</h2>
                                            </div>
                                            :
                                            <div className="col-sm-12  col-lg-12" style={{ margin: "0 auto" }}>
                                                <div className="table-responsive">
                                                    <table className="table align-items-center table-flush" style={styles.table}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={styles.tabletrtdhead}>SHOT</td>
                                                                <td style={styles.tabletrtdhead}>SUCCESS RATE</td>
                                                                {tournamentprocessreport.total == 1 ? <td style={styles.tabletrtdhead}>NOTES</td> : ""}
                                                            </tr>
                                                            <tr>
                                                                <td style={styles.tabletrtdleft}>DRIVING</td>
                                                                <td style={styles.tabletrtd}><strong>{reportlength==0 ? "" : tournamentprocessreport.driving+'%'}</strong></td>
                                                                {tournamentprocessreport.total == 1 ? <td style={styles.tabletrtd}>{tournamentprocessreport.drvnotes}</td> : ""}
                                                            </tr>
                                                            <tr>
                                                                <td style={styles.tabletrtdleft}>FWAY WOODS</td>
                                                                <td style={styles.tabletrtd}><strong>{reportlength==0 ? "" : tournamentprocessreport.fwaywood+'%'}</strong></td>
                                                                {tournamentprocessreport.total == 1 ? <td style={styles.tabletrtd}>{tournamentprocessreport.fwynotes}</td> : ""}
                                                            </tr>
                                                            <tr>
                                                                <td style={styles.tabletrtdleft}>APPROACH SHOTS</td>
                                                                <td style={styles.tabletrtd}><strong>{reportlength==0 ? "" : tournamentprocessreport.approach+'%'}</strong></td>
                                                                {tournamentprocessreport.total == 1 ? <td style={styles.tabletrtd}>{tournamentprocessreport.apprnotes}</td> : ""}
                                                            </tr>
                                                            <tr>
                                                                <td style={styles.tabletrtdleft}>WEDGE PLAY</td>
                                                                <td style={styles.tabletrtd}><strong>{reportlength==0 ? "" : tournamentprocessreport.wedge+'%'}</strong></td>
                                                                {tournamentprocessreport.total == 1 ? <td style={styles.tabletrtd}>{tournamentprocessreport.wedgenotes}</td> : ""}
                                                            </tr>
                                                            <tr>
                                                                <td style={styles.tabletrtdleft}>BUNKER PLAY</td>
                                                                <td style={styles.tabletrtd}><strong>{reportlength==0 ? "" : tournamentprocessreport.bunker+'%'}</strong></td>
                                                                {tournamentprocessreport.total == 1 ? <td style={styles.tabletrtd}>{tournamentprocessreport.bunkernotes}</td> : ""}
                                                            </tr>
                                                            <tr>
                                                                <td style={styles.tabletrtdleft}>CHIPPING</td>
                                                                <td style={styles.tabletrtd}><strong>{reportlength==0 ? "" : tournamentprocessreport.chipping+'%'}</strong></td>
                                                                {tournamentprocessreport.total == 1 ? <td style={styles.tabletrtd}>{tournamentprocessreport.chipnotes}</td> : ""}
                                                            </tr>
                                                            <tr>
                                                                <td style={styles.tabletrtdleft}>SPECIALITY</td>
                                                                <td style={styles.tabletrtd}><strong>{reportlength==0 ? "" : tournamentprocessreport.speciality+'%'}</strong></td>
                                                                {tournamentprocessreport.total == 1 ? <td style={styles.tabletrtd}>{tournamentprocessreport.spsnotes}</td> : ""}
                                                            </tr>
                                                            <tr>
                                                                <td style={styles.tabletrtdleft}>PUTTING</td>
                                                                <td style={styles.tabletrtd}><strong>{reportlength==0 ? "" : tournamentprocessreport.putting+'%'}</strong></td>
                                                                {tournamentprocessreport.total == 1 ? <td style={styles.tabletrtd}>{tournamentprocessreport.putnotes}</td> : ""}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        }
                                    </>
                                }
                            </RctCollapsibleCard>
                        </div>
                    </div>

                }

                {this.state.viewdiv3 &&
                    <ViewReport onClick={this.onBackSection} data={this.state} />
                }

                {this.state.adddiv &&
                    <AddItem onClick={this.onBackSection} data={this.state} />
                }

                {this.state.listdiv &&
                    <div className="col-sm-12 col-lg-8" style={{ margin: "0 auto" }}>
                        <RctCollapsibleCard heading="Tournament Score" fullBlock>
                            <MUIDataTable
                                title={<div><Button onClick={() => this.onBackSection()} className="btn btn-outline-warning"> Back</Button></div>}
                                data={tabledata}
                                columns={columns}
                                options={options}
                            />
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.editdiv &&
                    <EditItem onClick={this.onEditBack} data={this.state} />
                }

                {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                }

                <ConfirmationDialog
                    ref={this.confirmationDialog}
                    onConfirm={(res) => this.deleteDataPermanent(res)}
                    data={'tournament score'}
                />


                {this.state.addprdiv &&
                    <AddPRItem onClick={this.onBackSection} data={this.state} />
                }

                {this.state.listprdiv &&
                    <div className="col-sm-12 col-lg-8" style={{ margin: "0 auto" }}>
                        <RctCollapsibleCard heading="Tournament Process" fullBlock>
                            <MUIDataTable
                                title={<div><Button onClick={() => this.onBackSection()} className="btn btn-outline-warning"> Back</Button></div>}
                                data={tableprdata}
                                columns={columns2}
                                options={options}
                            />
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.editprdiv &&
                    <EditPRItem onClick={this.onEditPRBack} data={this.state} />
                }

                <ConfirmationDialog
                    ref={this.confirmationPRDialog}
                    onConfirm={(res) => this.deletePRDataPermanent(res)}
                    data={'tournament process'}
                />

            </div>
        )
    }
}

const mapStateToProps = ({ mostlyused, tournamentscore, tournamentprocess }) => {
    const { studentlists, loading } = mostlyused;
    const { tournamentscorelist } = tournamentscore;
    const { tournamentprocessreport, tournamentprocesslist } = tournamentprocess;
    return { studentlists, tournamentscorelist, tournamentprocessreport, tournamentprocesslist, loading };
}

export default connect(mapStateToProps, {
    studentTournamentScore,
    fetchTournamentProcessReport,
    fetchTournamentChart,
    fetchTournamentScore,
    deleteTournamentScore,
    fetchTournamentProcess,
    deleteTournamentProcess,
    studentTournamentProcess,
    fetchPlayerIntervention
})(TournamentData); 